import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Footer from "../../components/footer/Footer";
import GeneralInformation from "../../components/generalInformation/GeneralInformation";
import Sheet from "../../components/sheet/Sheet";
import styles from "./SpecsheetsPage.module.css";
import axios from "axios";
import { apiUrl } from "../../constants";
import createGoogleAnalyticsTemplateName from "../../helpers/createGoogleAnalyticsTemplateName";
import { TrackGoogleAnalyticsEvent } from "../../helpers/InitializeGoogleAnalytics";
import UpdateForm from "../../components/dynamicForm/updateForm/UpdateForm";
import Header from "../../components/header/Header";

// Here we receive the param from app.js and set is as param to be transferred to Sheet.js. Here we also combine three components together on one page
const SpecsheetPage = () => {
  const [name, setName] = useState("");
  const [additionalTemplateInformation, setAdditionalTemplateInformation] =
    useState("");
  const [response, setResponse] = useState([]);
  const [previewPages, setPreviewPages] = useState([]);
  const [creatives, setCreatives] = useState([]);
  const [previewLinks, setPreviewLinks] = useState([]);
  const [downloadLinks, setDownloadLinks] = useState([]);
  const [display, setDisplay] = useState(false);
  const [lastUpdate, setLastUpdate] = useState("");
  const [showModifyForm, toggleShowModifyForm] = useState(false);

  let navigate = useNavigate();
  let { active, id } = useParams();

  const showNavigation = false;

  // Here set the google analytics tracking
  useEffect(() => {
    if (name !== "") {
      TrackGoogleAnalyticsEvent(
        "view",
        `viewed: ${createGoogleAnalyticsTemplateName(name)}`,
        name
      );
    }
  }, [name]);

  // Here we receive the id and active state from the param and get the specsheet data and we set the data. We always send a token now even if it is not needed. In order to get an error from the backend if a notActive specsheets is requested by a non Admin user.
  useEffect(() => {
    async function getData() {
      const jwtToken = localStorage.getItem("token");
      try {
        const { data } = await axios.get(
          `${apiUrl}/specsheets/${active}/${id}`,
          {
            headers: {
              Authorization: `Bearer ${jwtToken}`,
            },
          }
        );
        setLastUpdate(data[0].specsheet.lastUpdate);
        setAdditionalTemplateInformation(
          data[0].specsheet.additionalTemplateInformation
        );
        setResponse(data[0].specsheet);
        setCreatives(data[0].specsheet.creatives);
        setName(data[0].specsheet.templateName);
        setPreviewLinks(data[0].specsheet.previews);
        setDownloadLinks(data[0].specsheet.downloadFormat);
        setPreviewPages(data[0].specsheet.previewPages);

        setDisplay(true);
      } catch (e) {
        console.error(e);
        setDisplay(false);
        navigate("*");
      }
    }
    if (id) {
      getData();
    }
  }, [id]);

  return (
    <div>
      <Header showNavigation={showNavigation} />
      {display && (
        <div className={styles["specsheet-container"]}>
          {!showModifyForm && (
            <Sheet
              lastUpdate={lastUpdate}
              creatives={creatives}
              name={name}
              additionalTemplateInformation={additionalTemplateInformation}
              previewLinks={previewLinks}
              downloadLinks={downloadLinks}
              previewPages={previewPages}
              toggleShowModifyForm={toggleShowModifyForm}
            />
          )}
          {showModifyForm && (
            <UpdateForm
              response={response}
              id={id}
              toggleShowModifyForm={toggleShowModifyForm}
            />
          )}
          {!showModifyForm && <GeneralInformation name={name} />}
          {!showModifyForm && <Footer />}
        </div>
      )}
    </div>
  );
};

export default SpecsheetPage;
